export default __webpack_public_path__ + "static/media/snow-avalanche.b0726ca2.svg";